export default "__VITE_ASSET__d249cb21__"